import { messagingActions } from 'messaging/redux/messagingActions';
import { messagingSelectors } from 'messaging/redux/messagingSelectors';
import { select, put, call } from 'redux-saga/effects';
import { unsubscribeChannel } from './firebaseUtils';

export function* unsubscribePreviousChannel(): Generator {
    const previousChannelId = yield select(messagingSelectors.previousSelected);

    if (!previousChannelId) {
        return;
    }

    const channelId = String(previousChannelId);

    yield put(messagingActions.channelViewed(channelId));
    yield call(unsubscribeChannel, `channels/${channelId}/messages`);
}
